import {
    BlockNoteEditor,
    defaultProps,
    insertOrUpdateBlock,
} from "@blocknote/core";
import { createReactBlockSpec } from "@blocknote/react";
import { IconBrandYoutube, IconSettings } from "@tabler/icons-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export const VideoBlock = createReactBlockSpec(
    {
        type: "videoblock",
        propSchema: {
            url: {
                default: "",
            },
        },
        content: "none",
    },
    {
        render: ({ block, editor }) => {
            const { url } = block.props;

            const getEmbedUrl = (url: string) => {
                if (url.includes("youtube.com") || url.includes("youtu.be")) {
                    const videoId = url.includes("youtube.com")
                        ? url.split("v=")[1]?.split("&")[0]
                        : url.split("youtu.be/")[1]?.split("?")[0];
                    return `https://www.youtube.com/embed/${videoId}`;
                }
                return url;
            };

            return (
                <div className="my-4 w-full">
                    <div
                        className={cn(
                            "flex flex-col gap-2",
                            editor.isEditable &&
                                "w-full rounded-md bg-muted p-4"
                        )}
                    >
                        {editor.isEditable && (
                            <div className="flex w-full items-center">
                                <div className="h-10 w-fit rounded-l-md bg-card px-3 py-2">
                                    <p className="w-fit text-nowrap">
                                        YouTube Video URL
                                    </p>
                                </div>
                                <Input
                                    variant="card"
                                    className="w-full rounded-l-none"
                                    type="url"
                                    value={url}
                                    onChange={(e) =>
                                        editor.updateBlock(block, {
                                            props: {
                                                url: e.target.value,
                                            },
                                        })
                                    }
                                    placeholder="Paste YouTube URL here"
                                />
                            </div>
                        )}

                        {url && (
                            <div className="relative aspect-video w-full">
                                <iframe
                                    src={getEmbedUrl(url)}
                                    className="absolute h-full w-full rounded-md"
                                    allowFullScreen
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                />
                            </div>
                        )}
                    </div>
                </div>
            );
        },
    }
);

export const insertVideoBlock = () => ({
    title: "YouTube Video",
    group: "Advanced",
    onItemClick: (editor: BlockNoteEditor) => {
        insertOrUpdateBlock(editor, {
            // @ts-ignore
            type: "videoblock",
        });
    },
    aliases: ["youtube", "embed", "video"],
    icon: <IconBrandYoutube />,
    subtext: "Embed a video from YouTube",
});
